import IconCamera from "./IconCamera";
export default IconCamera;
